import { useListMedia } from '@reelplicate/api-client/media';
import { useMemo } from 'react';

/** The library's reels with a scene breakdown, newest first as the library lists them. */
export function useReelsWithScenes(workspaceId: string) {
  const { data } = useListMedia(workspaceId, {
    query: { enabled: Boolean(workspaceId), throwOnError: false },
  });
  const reels = useMemo(
    () =>
      data?.items.filter((asset) => asset.kind === 'REEL' && asset.scenes?.length) ?? [],
    [data],
  );
  return { reels, loading: !data };
}
